import { FormattedMessage } from 'react-intl'
import Step from '../../../../../ModalStepsOutline'
import WhereStepBody from './WhereStepBody'
import styles from './Where.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import {
  setScheduleTourStepAdvanceOneStep,
  selectScheduleTourStep,
  setScheduleTourShowModal,
  setScheduleTourStep,
  STEPS,
  STEPS_CONST,
  STEPS_REA
} from '../../../../../../../../store/slices/scheduleTour'
import { selectCustomerIsRealEstateAgent } from '../../../../../../../../store/selectors/customerProfile'

export const Where = () => {
  const dispatch = useDispatch()

  const currentStep = useSelector(selectScheduleTourStep)
  const stepIndex = STEPS.indexOf(currentStep)
  const isCustomerREA = useSelector(selectCustomerIsRealEstateAgent)

  const handleButtonClick = () => {
    dispatch(setScheduleTourStepAdvanceOneStep())
  }

  return (
    <Step stepLabel='schedule-tour-location'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={isCustomerREA ? STEPS_REA : STEPS}
        onCancel={() => dispatch(setScheduleTourShowModal(false))}
        onBack={() => dispatch(setScheduleTourStep(STEPS_CONST[stepIndex - 1]))}
      />
      <Step.Title>
        <FormattedMessage id='ScheduleTour.Where.Label' defaultMessage='How do you want to tour?' />
      </Step.Title>
      <Step.Body className={styles.bodySection}>
        <WhereStepBody />
      </Step.Body>
      <Step.FooterButton onClick={handleButtonClick}>
        <FormattedMessage id='ScheduleTour.FooterButton.NextStep' defaultMessage='Next Step' />
      </Step.FooterButton>
    </Step>
  )
}
